import React from "react";
import {
  getMemberSearchFilterDisplays,
  type MemberSearchCriteria,
} from "../memberSearchQuery";

type MemberSearchSelectedFiltersProps = {
  criteria: MemberSearchCriteria;
};

const MemberSearchSelectedFilters: React.FC<MemberSearchSelectedFiltersProps> = ({
  criteria,
}) => {
  const filters = getMemberSearchFilterDisplays(criteria);

  return (
    <div className="border-b border-t pt-5 pb-7">
      <div className="text-left text-sm leading-5 text-primary md:text-sm lg:text-base">
        <div className="flex flex-col md:flex-row md:items-start">
          <div className="mb-2 flex shrink-0 items-center md:mb-0">
            <span className="whitespace-nowrap font-semibold">Selected Filters</span>
            <div className="mx-3 hidden h-4 w-[1px] bg-gray-400 md:block" />
          </div>
          <div className="flex flex-col gap-y-1 text-gray-font md:flex-row md:flex-wrap md:items-center md:gap-y-0">
            {filters.map((filter, index) => (
              <React.Fragment key={filter.label}>
                <span>
                  <span className="text-sm font-bold leading-5 md:text-sm lg:text-base">
                    {filter.label}:
                  </span>{" "}
                  {filter.value}
                </span>
                {index < filters.length - 1 ? (
                  <span className="mx-3 hidden md:inline" aria-hidden="true">
                    •
                  </span>
                ) : null}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberSearchSelectedFilters;
